import styled from 'styled-components'
import { grid, GridProps, margin, MarginProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<GridProps>`
  display: grid;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.8')}px;

  ${grid}
`

export const StyledButton = styled.button.withConfig({
  shouldForwardProp,
})<MarginProps>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.2')}px;
  color: ${themeGet('colors.primary.main')};
  font-size: ${themeGet('fontSizes.2')}px;
  font-weight: ${themeGet('fontWeights.1')};

  &:hover {
    color: ${themeGet('colors.primary.dark')};
  }

  ${margin}
`
